<script lang="ts">
  import AwesomePage from "../../components/awesome-page.svelte";
  import Page from "../../components/page.svelte";

  export let data;

  $: page = data.homepage;
  $: settings = data.settings;
  $: schedule = data.schedule;
  $: events = data.events;
  $: announcements = data.announcements;
</script>

{#if page.layout == "dashboard"}
  <AwesomePage {announcements} {page} hero={settings.hero} {schedule} {events} />
{:else}
  <Page {page} />
{/if}
